import { ICustomizationSubmodule } from "../types";
import { ILLFAttributeRegistrator, ILLFTemplateRegistrator } from "./types";

export class LiteListFrameCustomization implements ICustomizationSubmodule {
    private _attribute: ILLFAttributeRegistrator | undefined;
    private _template: ILLFTemplateRegistrator | undefined;

    /**
     * Inicializační metoda, která nastaví registrátory.
     *
     * @param attributeRegistrator Registrátor pro attribute na LLF.
     * @internal
     */
    public init(attributeRegistrator: ILLFAttributeRegistrator, templateRegistrator: ILLFTemplateRegistrator): void {
        if (!this._attribute) {
            this._attribute = attributeRegistrator;
            this._template = templateRegistrator;
        }
    }

    /**
     * Získá registrátor pro atribut na LLF.
     */
    public get attribute(): ILLFAttributeRegistrator {
        if (!this._attribute) {
            throw new Error(`[Customization] LLFAttribute registrator is not defined.
            Please check if initialization was called.`);
        }
        return this._attribute;
    }

    public get templates(): ILLFTemplateRegistrator {
        if (!this._template) {
            throw new Error(`[Customization] LLFTemplate registrator is not defined.
            Please check if initialization was called.`);
        }
        return this._template;
    }
}
